import { useCallback } from "react";

import { useActiveBrokerAccountOptional } from "../../../contexts/ActiveBrokerAccountContext";
import { accountLabel } from "./liveStrategiesFormat";

/**
 * Account numbers as the broker shows them, like the sidebar picker: cTrader deployments store
 * the Open API ctid (49256535), but people know the account by its login (5944960).
 * `fallback` is used when the account isn't in the trade-accounts list (e.g. a setup label).
 */
export function useAccountLabel(): (
  brokerName: string | null | undefined,
  code: string | null | undefined,
  fallback?: string | null
) => string {
  const accounts = useActiveBrokerAccountOptional()?.accounts;
  return useCallback(
    (brokerName, code, fallback) => {
      const bn = String(brokerName ?? "").toLowerCase();
      const hit = code
        ? accounts?.find((a) => a.accountCode === code && (!bn || a.brokerName === bn))
        : undefined;
      return accountLabel(hit?.platformLogin || fallback || code);
    },
    [accounts]
  );
}
